<template>

    <statement
               class="pt-2"
               color="transparent"
               :query="query"
               :data-variables="dataVariables"
               :disable-edit="true">
    </statement>

</template>

<script>

    import Statement from './Statement';

    export default {

        components: {
            Statement
        },

        props: {
            query: {
                type: Object,
                required: true,
            },
            dataVariables: {
                type: Array,
                required: true
            },
        },
    }
</script>
